import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";

import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { IdeaAuthorName } from "../aprove-idea-authors/types/idea-author-name.type";
import { UpdateIdeaAuthorGQL } from "src/generated/graphql/idea/author/idea-author.graphql";
import { CustomvalidationService } from "./authors.validation";
import { Active } from "src/app/model/dashboard/active";
import {
  GetAuthorsByIdeaGQL,
  UpdateAuthorsGQL,
} from "src/generated/graphql/idea/author/idea-autor-by-id.graphql";
import { take } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { Author, AuthorInput, IdeaAuthor } from "./authors.type";
import { BaseComponent } from "src/app/base/base.component";
import { AuthorService } from "src/app/service-state/authors-state.service";
import { UserService } from "src/app/service/user.service";

@Component({
  selector: "app-authors",
  templateUrl: "./authors.component.html",
  styleUrls: ["./authors.component.scss"],
})
export class AuthorsComponent extends BaseComponent implements OnInit {
  formAuthor: FormGroup;
  formAuthorDeleted: FormArray;

  @Input() authorsRe: IdeaAuthorName[];

  idIdea: string;
  url: { id: string; code: string };

  statusCode: boolean;

  @Output()
  getInforsOfFormAuthors = new EventEmitter();

  formGroupsErrors: FormGroup[];

  constructor(
    private fb: FormBuilder,
    public route2: ActivatedRoute,
    public router: Router,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    private getAuthorByIdeaGQL: GetAuthorsByIdeaGQL,
    private postAuthorsByIdeaGQL: UpdateAuthorsGQL,
    private validadtionService: CustomvalidationService,
    private authorService: AuthorService,
    public userService: UserService,
  ) {
    super(router, loading, translate);

    this.formAuthor = this.fb.group(
      {
        authors: this.fb.array([]),
      },
      { validators: [this.validadtionService.patternValidator()] },
    );

    this.formAuthor
      .get("authors")
      .valueChanges.subscribe((value: FormArray) => {
        this.authorService.updateAuthorCount(value.length);
      });

    this.formAuthorDeleted = this.fb.array([]);
  }

  ngOnInit(): void {
    this.getUrlParams();
    this.findAllIdeaAuthors();
    this.setInforsOfFormAuthors();
  }

  setInforsOfFormAuthors(): void {
    this.getInforsOfFormAuthors.emit(this.formAuthor.dirty);
  }

  getUrlParams() {
    this.url = this.route2.snapshot.params as { id: string; code: string };
    this.idIdea = this.url.id;
  }

  findAllIdeaAuthors() {
    const query = this.getAuthorByIdeaGQL.watch({ id: this.url.id });
    query.valueChanges.pipe(take(1)).subscribe(({ data }) => {
      const authorsFormArray = this.formAuthor.get("authors") as FormArray;
      authorsFormArray.clear();

      const author: AuthorInput = data.getAuthorsByIdea;
      let group_form = this.fb.group({
        id: "",
        name: [
          { value: author.authorName, disabled: true },
          [Validators.required],
        ],
        re: [
          { value: author.re, disabled: true },
          [Validators.required, Validators.pattern("^[0-9]*$")],
        ],
        email: [{ value: author.email, disabled: true }, [Validators.required]],
        jobRole: [author.role, [Validators.required]],
        cpf: [
          author.document,
          [this.validadtionService.cpfValidator()],
        ],
        costCenter: [author.costCenter, [Validators.required]],
        area: [author.areaResponsible, [Validators.required]],
        remove: false,
        edit: false,
        isMain: true,
        justification: null,
        changed: false,
        setMain: false,
        active: true,
        new: false,
        parent: null,
      });
      (this.formAuthor.get("authors") as FormArray).push(group_form);

      this.setAuthorsOfForm(author.authors);

      if (this.formAuthor.status == "INVALID") {
        this.getErrorsForm();
      }
    });
  }

  getErrorsForm() {
    const formGroupErrors: FormGroup[] = [];
    this.authorForms.controls.forEach((formAuthor: FormGroup) => {
      Object.keys(formAuthor.controls).forEach((key) => {
        const control = formAuthor.get(key);
        if (control?.errors) {
          formGroupErrors.push(formAuthor);
          formAuthor.get("name").enable();
          formAuthor.get("re").enable();
          formAuthor.get("email").enable();
          formAuthor.patchValue({
            edit: true,
          });
        }
      });
    });
    this.formGroupsErrors = formGroupErrors;
  }

  setAuthorsOfForm(authors: IdeaAuthor[]) {
    authors.forEach((authorInput: IdeaAuthor) => {
      if (!authorInput.remove) {
        let group_form = this.fb.group({
          id: [authorInput.id],
          name: [
            { value: authorInput.name, disabled: true },
            [Validators.required],
          ],
          re: [
            { value: authorInput.re, disabled: true },
            [Validators.required, Validators.pattern("^[0-9]*$")],
          ],
          email: [
            { value: authorInput.email, disabled: true },
            [Validators.required],
          ],
          jobRole: [authorInput.jobRole, [Validators.required]],
          cpf: [authorInput.cpf, [this.validadtionService.cpfValidator()]],
          costCenter: [authorInput.costCenter],
          area: [authorInput.area, [Validators.required]],
          remove: authorInput.remove ? authorInput.remove : false,
          edit: false,
          isMain: false,
          justification: null,
          changed: false,
          active: authorInput.remove ? false : true,
          setMain: false,
          new: false,
          parent: null,
        });
        (this.formAuthor.get("authors") as FormArray).push(group_form);
      } else {
        let group_form = this.fb.group({
          id: [authorInput.id],
          name: [
            { value: authorInput.name, disabled: true },
            [Validators.required],
          ],
          re: [
            { value: authorInput.re, disabled: true },
            [Validators.required, Validators.pattern("^[0-9]*$")],
          ],
          email: [
            { value: authorInput.email, disabled: true },
            [Validators.required],
          ],
          jobRole: [authorInput.jobRole, [Validators.required]],
          cpf: [
            authorInput.cpf,
            [this.validadtionService.cpfValidator()],
          ],
          costCenter: [authorInput.costCenter, [Validators.required]],
          area: [authorInput.area, [Validators.required]],
          remove: authorInput.remove,
          edit: false,
          isMain: false,
          justification: null,
          changed: false,
          active: authorInput.remove ? false : true,
          setMain: false,
          new: false,
          parent: null,
        });

        this.formAuthorDeleted.push(group_form);
      }
    });
  }

  get authorForms(): FormArray {
    return this.formAuthor.get("authors") as FormArray;
  }

  onBlurCpf(index: number) {
    let author = this.authorForms.at(index);
    const cpf = author.get("cpf").value?.replace(/[\s.-]*/gim, "");
    author.get("cpf").setValue(cpf);
  }

  addAuthor(): void {
    this.statusCode = false;
    this.authorForms.push(
      this.fb.group({
        id: "",
        name: [null, [Validators.required]],
        re: [null, [Validators.required, Validators.pattern("^[0-9]*$")]],
        email: [null, [Validators.required, Validators.email]],
        remove: false,
        jobRole: [null, [Validators.required]],
        cpf: [
          null,
          [this.validadtionService.cpfValidator()],
        ],
        costCenter: [null, [Validators.required]],
        area: [null, [Validators.required]],
        edit: false,
        isMain: false,
        justification: null,
        changed: false,
        active: true,
        new: true,
        parent: null,
        setMain: false,
      }),
    );
  }

  removeFormAuthor(index: number): void {
    this.authorForms.removeAt(index);
    this.formAuthor.markAsDirty();
    this.setInforsOfFormAuthors();
  }

  removeAuthor(index: number): void {
    this.formAuthor.markAsDirty();
    this.setInforsOfFormAuthors();
    let author = this.authorForms.at(index);
    author.patchValue({
      remove: true,
      active: true,
      edit: true,
    });
  }

  changeAuthor(index: number): void {
    let author = this.authorForms.at(index);
    author.get("name").enable();
    author.get("re").enable();
    author.get("email").enable();
    author.patchValue({
      edit: true,
    });
  }

  closeAuthorEdit(index: number): void {
    let author = this.authorForms.at(index);
    author.get("name").disable();
    author.get("re").disable();
    author.get("email").disable();
    author.patchValue({
      edit: false,
    });
  }

  setMain(index: number): void {
    this.formAuthor.markAsDirty();
    this.setInforsOfFormAuthors();
    let author = this.authorForms.at(index);
    let oldAuthorMain = this.authorForms.controls.filter(
      (data) => data.get("isMain").value,
    );
    oldAuthorMain[0].patchValue({
      isMain: false,
      setMain: false,
    });
    author.patchValue({
      isMain: true,
      setMain: true,
    });
  }

  changedAuthor(index: number): void {
    let author = this.authorForms.at(index);

    author.patchValue({
      active: false,
    });
    const formGroupChanged = this.fb.group({
      id: "",
      name: ["", [Validators.required]],
      re: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
      email: ["", [Validators.required]],
      remove: false,
      edit: false,
      jobRole: ["", [Validators.required]],
      cpf: ["", [this.validadtionService.cpfValidator()]],
      costCenter: ["", [Validators.required]],
      area: ["", [Validators.required]],
      isMain: false,
      justification: [null, [Validators.required]],
      changed: true,
      active: true,
      new: false,
      parent: this.fb.group({
        name: { value: author.get("name").value, disabled: true },
        id: { value: author.get("id").value, disabled: true },
      }),
      setMain: false,
    });

    formGroupChanged.get("parent").disable();
    this.authorForms.push(formGroupChanged);
    if (author.get("isMain").value) {
      const indexGroupChanged =
        this.authorForms.controls.indexOf(formGroupChanged);
      this.setMain(indexGroupChanged);
    }
  }

  hasRequiredErrorSave(formGroup: FormGroup): boolean {
    return Object.values(formGroup.controls).some((data: FormGroup) =>
      Object.values(data.controls).some((control) =>
        control.hasError("required"),
      ),
    );
  }

  seveAuthors(): void {
    this.formAuthor.controls.authors.updateValueAndValidity();
    let changedValues = true;
    if (this.formAuthor.invalid) {
      this.formAuthor.markAsTouched();
      changedValues = this.formGroupsErrors.every((group) => {
        return (this.formAuthor.get("authors") as FormArray).controls.some(
          (obj) => {
            if (
              obj.get("parent")?.get("name")?.value === group.value.name &&
              obj.status === "VALID"
            ) {
              group.patchValue({ edit: false });
              return true;
            }
          },
        );
      });
      if (!changedValues) {
        console.log("Formulário inválido:", this.formAuthor.errors);
        return;
      }
    }

    if (
      !this.formAuthor.errors?.maxAuthorsValidated &&
      changedValues &&
      !this.hasRequiredErrorSave(this.formAuthor)
    ) {
      this.authorForms.controls.forEach((control) => {
        if (control.value.changed) {
          control.patchValue({
            justification: `${this.userService.getUserLocal().name} - ${control.value.justification}`,
          });
        }
      });

      const values = this.authorForms
        .getRawValue()
        .filter((author) => author.active);
      this.postAuthorsByIdeaGQL
        .mutate({
          id: this.idIdea,
          authorsInput: values,
        })
        .subscribe({
          next: () => {
            setTimeout(() => {
              this.findAllIdeaAuthors();
            }, 1000);
            this.getInforsOfFormAuthors.emit(false);
            this.showMessage(
              "Sucesso",
              "Autores atualizados com sucesso!",
              "success",
            );
          },
          error: (error) => {
            this.showMessage("Atenção", "Erro ao salvar autores");
          },
        });
    }
  }
}
